module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "battle_honours"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_xv"
    }
  }, [_c('p', {
    staticClass: "chap-title paracenter",
    staticStyle: {
      "margin-top": "2em"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("BATTLE HONOURS")])]), _vm._v(" "), _c('p', {
    staticClass: "paracenter"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/forward-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "paracenter",
    staticStyle: {
      "margin-top": "6em"
    }
  }, [_vm._v("Burma, 1885–87")]), _vm._v(" "), _c('p', {
    staticClass: "paracenter"
  }, [_vm._v("Helles")]), _vm._v(" "), _c('p', {
    staticClass: "paracenter"
  }, [_vm._v("Krithia")]), _vm._v(" "), _c('p', {
    staticClass: "paracenter"
  }, [_vm._v("Suvla")]), _vm._v(" "), _c('p', {
    staticClass: "paracenter"
  }, [_vm._v("Sari Bair")]), _vm._v(" "), _c('p', {
    staticClass: "paracenter"
  }, [_vm._v("Gallipoli 1915")]), _vm._v(" "), _c('p', {
    staticClass: "paracenter"
  }, [_vm._v("Suez Canal")]), _vm._v(" "), _c('p', {
    staticClass: "paracenter"
  }, [_vm._v("Egypt 1915–16")]), _vm._v(" "), _c('p', {
    staticClass: "paracenter"
  }, [_vm._v("Khan Baghdadi")]), _vm._v(" "), _c('p', {
    staticClass: "paracenter"
  }, [_vm._v("Mesopotamia, 1916–18")]), _vm._v(" "), _c('p', {
    staticClass: "paracenter"
  }, [_vm._v("Persia, 1918")]), _vm._v(" "), _c('p', {
    staticClass: "paracenter"
  }, [_vm._v("N. W. Frontier, India, 1915")]), _vm._v(" "), _c('p', {
    staticClass: "paracenter"
  }, [_vm._v("Afghanistan, 1919")]), _vm._v(" "), _c('p', {
    staticClass: "paracenter"
  }, [_vm._v("Coriano")]), _vm._v(" "), _c('p', {
    staticClass: "paracenter"
  }, [_vm._v("Santarcangelo")]), _vm._v(" "), _c('p', {
    staticClass: "paracenter"
  }, [_vm._v("Monte Chicco")]), _vm._v(" "), _c('p', {
    staticClass: "paracenter"
  }, [_vm._v("Lamone Crossing")]), _vm._v(" "), _c('p', {
    staticClass: "paracenter"
  }, [_vm._v("Senio Floodbank")]), _vm._v(" "), _c('p', {
    staticClass: "paracenter"
  }, [_vm._v("Medicina")]), _vm._v(" "), _c('p', {
    staticClass: "paracenter"
  }, [_vm._v("Gaiana Crossing")]), _vm._v(" "), _c('p', {
    staticClass: "paracenter"
  }, [_vm._v("Italy, 1944–45")]), _vm._v(" "), _c('p', {
    staticClass: "paracenter"
  }, [_vm._v("Shwebo")]), _vm._v(" "), _c('p', {
    staticClass: "paracenter"
  }, [_vm._v("Kyaukmyaung Bridgehead")]), _vm._v(" "), _c('p', {
    staticClass: "paracenter"
  }, [_vm._v("Mandalay")]), _vm._v(" "), _c('p', {
    staticClass: "paracenter"
  }, [_vm._v("Fort Dufferin")]), _vm._v(" "), _c('p', {
    staticClass: "paracenter"
  }, [_vm._v("Maymyo")])]), _c('a', {
    attrs: {
      "id": "page_xvi"
    }
  }, [_c('p', {
    staticClass: "paracenter"
  }, [_vm._v("Rangoon Road")]), _vm._v(" "), _c('p', {
    staticClass: "paracenter"
  }, [_vm._v("Toungoo")]), _vm._v(" "), _c('p', {
    staticClass: "paracenter"
  }, [_vm._v("Sittang, 1945")]), _vm._v(" "), _c('p', {
    staticClass: "paracenter"
  }, [_vm._v("Chindits, 1944")]), _vm._v(" "), _c('p', {
    staticClass: "paracenter"
  }, [_vm._v("Burma, 1944–45")]), _vm._v(" "), _c('p', {
    staticClass: "paranoindent1",
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_vm._v("The Battle Honours awarded previous to "), _c('em', [_vm._v("Burma")]), _vm._v(", "), _c('em', [_vm._v("1885–87")]), _vm._v(", viz: "), _c('em', [_vm._v("Arracan")]), _vm._v(", "), _c('em', [_vm._v("Assam")]), _vm._v(" and "), _c('em', [_vm._v("Ava")]), _vm._v(" do not appear to have been carried forward in the Army List.")])])]), _c('a', {
    attrs: {
      "id": "page_xvi"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6ad6e597","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/10_battle_honours.vue
// module id = 81
// module chunks = 0